import React from "react";
import { useAppContext } from "../../apps/tickets/context/context";

const HeroSection = (props) => {
  const { t, handleSearch = () => {} , setSearchQuery = () => {} , searchQuery = "", isUsersView , showText = true} = props;
  const {searchQuery:searchquery} = useAppContext() ; 
  return (
    <div style={{zIndex : "500"}} className=" fixed top-[0.7rem] right-[4rem] sm:right-[250px]  px-1 sm:px-2 md:px-4 md:mr-9">
      <div className="max-w-[190px]  overflow-hidden sm:max-w-[40rem] md:max-w-[40rem] lg:max-w-lg">
        <form
          className="flex w-full rounded-l-lg overflow-hidden "
          onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
          }}
        >
          <input
            type="text"
            className="w-full rounded-l-lg   px-3 sm:px-3 md:px-4 py-2 text-sm sm:text-base border border-gray-300 focus:outline-none focus:ring-2 focus:border-transparent"
            placeholder={isUsersView ? t("createAsset.buttons.searchByUsers") : showText ? t("createAsset.buttons.Search By Id") : t("createAsset.buttons.Search")}
            value={searchQuery ? searchQuery : searchquery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button
            type="submit"
            className="bg-[#007bff] rounded-r-lg  hover:bg-blue-700 text-white px-2 sm:px-3 md:px-4 py-1 sm:py-2 text-sm sm:text-base  transition duration-200 flex items-center justify-center"
          >
            <span className="hidden sm:inline">{t("createAsset.buttons.Search")}</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 sm:hidden"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </button>
        </form>
      </div>
    </div>
  );
};

export default HeroSection;
